//@ts-ignore
import { EXTERNAL_LMS_SLUGS, ExternalHomework } from '@yandex-int/k-common/typings';
import { MesLogo as MesLogoIcon, ExternalLink as ExternalLinkIcon } from 'education-icons';
import { Text } from 'platform-components';
import React from 'react';
import { connect } from 'react-redux';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import * as lessonSelectors from 'common.components/lesson/selectors';
import { getMesHost } from 'utils/external-lms/external-lms';

import './side-panel__external-link.scss';

interface StoreProps {
    externalHomework: ExternalHomework | null;
}

interface Props extends StoreProps {}

export const ExternalLink = (props: Props) => {
    const { externalHomework } = props;

    if (!externalHomework) {
        return null;
    }

    if (externalHomework?.lms === EXTERNAL_LMS_SLUGS.MES) {
        const redirectToMesJournal = () => {
            const { homework_id: homeworkId, homework_entry_id: entryId } = externalHomework;
            const mesHost = getMesHost();
            window.location.href = `${mesHost}/journal/study/journals/homeworks/${homeworkId}/info?homework_entry_id=${entryId}`;
        };

        return (
            <div className="side-panel__external-link" {...accessibleClick(redirectToMesJournal)}>
                <MesLogoIcon className="side-panel__external-link-mes-logo" />
                <Text id="lessonView.sidePanel.mesLink" />
                <ExternalLinkIcon className="side-panel__external-link-icon" />
            </div>
        );
    }

    return null;
};

const mapStateToProps = (storeState: any): StoreProps => {
    return {
        externalHomework: lessonSelectors.getExternalHomework(storeState),
    };
};

const connected = connect(mapStateToProps)(ExternalLink);
connected.displayName = 'ExternalLink';

export default connected;
